import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
  key: 1,
  ref: "quizzesResultsContainer",
  class: "quizzes-results-container"
};
const _hoisted_2 = {
  class: "quizzes-results-pdf-title",
  "only-display-in-pdf": ""
};
const _hoisted_3 = {
  class: "quiz-results-header"
};
const _hoisted_4 = {
  key: 0,
  class: "exam-quiz-summary"
};
const _hoisted_5 = {
  class: "chapter-name"
};
const _hoisted_6 = {
  "only-display-in-pdf": ""
};
const _hoisted_7 = {
  class: "percentage-info",
  "hide-in-pdf": ""
};
const _hoisted_8 = {
  key: 0,
  class: "nb-tries-info"
};
const _hoisted_9 = {
  "hide-in-pdf": ""
};
const _hoisted_10 = {
  key: 1,
  class: "no-results-quiz-summary"
};
const _hoisted_11 = {
  class: "chapter-name"
};
const _hoisted_12 = {
  class: "results-state-info"
};
const _hoisted_13 = {
  key: 1,
  class: "chapter-name"
};
const _hoisted_14 = {
  class: "quiz-results-detail-container"
};
const _hoisted_15 = {
  key: 0,
  class: "quiz-results-detail"
};
const _hoisted_16 = {
  key: 1,
  class: "quiz-results-detail"
};
const _hoisted_17 = {
  key: 2,
  class: "quiz-results-detail"
};
const _hoisted_18 = ["innerHTML"];
const _hoisted_19 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_loader = _resolveComponent("loader");
  const _component_reset_quiz_button = _resolveComponent("reset-quiz-button");
  const _component_exam_quiz_questions_results = _resolveComponent("exam-quiz-questions-results");
  const _component_survey_quiz_questions = _resolveComponent("survey-quiz-questions");
  const _component_open_question = _resolveComponent("open-question");
  const _component_standard_button = _resolveComponent("standard-button");
  const _component_w_dialog = _resolveComponent("w-dialog");
  return _openBlock(), _createBlock(_component_w_dialog, {
    visible: _ctx.isVisible,
    title: _ctx.$t('analytics.userQuizzesResultsDialog.title'),
    width: "800px",
    class: "user-quizzes-results-dialog",
    onOnDialogClose: _ctx.closePopup
  }, _createSlots({
    default: _withCtx(() => [!_ctx.quizzesLoaded ? (_openBlock(), _createBlock(_component_loader, {
      key: 0,
      class: "loader"
    })) : _ctx.userOverallQuizzes && _ctx.quizzesResultsExist ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('analytics.userQuizzesResultsDialog.pdfExport.title', {
      userName: _ctx.userOverallQuizzes.userName,
      speachTitle: _ctx.userOverallQuizzes.speachTitle
    })), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quizzesResults, (quizResults, index) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['quiz-results-container', {
          'first': index === 0
        }])
      }, [_createElementVNode("div", _hoisted_3, [quizResults.quiz.quizType === _ctx.QuizType.QUIZZ_EXAMEN ? (_openBlock(), _createElementBlock("div", _hoisted_4, [quizResults.quizResultState === _ctx.QuizResultState.QUIZZ_TERMINE || quizResults.quizResultState === _ctx.QuizResultState.QUIZZ_A_VALIDER ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_5, [_createTextVNode(_toDisplayString(quizResults.chapterName) + " ", 1), _createElementVNode("span", _hoisted_6, " (" + _toDisplayString(_ctx.$t('analytics.userQuizzesResultsDialog.pdfExport.percentageMessage', {
        percentage: quizResults.percentage,
        completionDate: quizResults.quizResultDate
      })) + ")", 1)]), _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('analytics.userQuizzesResultsDialog.achievedResults', {
        percentage: quizResults.percentage
      })), 1), quizResults.quizResultState === _ctx.QuizResultState.QUIZZ_A_VALIDER ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.getNbTriesMsg(quizResults.remainingTries)), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_reset_quiz_button, {
        "quizz-id": quizResults.quizResultsId,
        "id-achat-cour": _ctx.userOverallQuizzes.idAchatCour,
        "speach-id": _ctx.userOverallQuizzes.speachID
      }, null, 8, ["quizz-id", "id-achat-cour", "speach-id"])])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(quizResults.chapterName), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('analytics.userQuizzesResultsDialog.userResultNotAvailableInfo')), 1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(quizResults.chapterName), 1))]), _createElementVNode("div", _hoisted_14, [quizResults.questions?.length > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [quizResults.quiz.quizType === _ctx.QuizType.QUIZZ_EXAMEN ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(_component_exam_quiz_questions_results, {
        questions: quizResults.quiz.questions,
        "user-answers": quizResults.questions
      }, null, 8, ["questions", "user-answers"])])) : quizResults.quiz.quizType === _ctx.QuizType.ENQUETE ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_survey_quiz_questions, {
        quiz: quizResults.quiz,
        "user-questions-answers": quizResults.questions,
        "is-result-mode": true
      }, null, 8, ["quiz", "user-questions-answers"])])) : quizResults.quiz.quizType === _ctx.QuizType.QUESTION_OUVERTE ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_open_question, {
        quiz: quizResults.quiz,
        "user-questions-answers": quizResults.questions,
        "is-result-mode": true
      }, null, 8, ["quiz", "user-questions-answers"])])) : _createCommentVNode("", true)], 64)) : quizResults.quizResultHtml ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        innerHTML: quizResults.quizResultHtml,
        class: "quiz-results-detail-html"
      }, null, 8, _hoisted_18)) : _createCommentVNode("", true)])], 2);
    }), 256))], 512)) : _createCommentVNode("", true)]),
    _: 2
  }, [_ctx.quizzesResultsExist ? {
    name: "footer",
    fn: _withCtx(() => [_createElementVNode("span", _hoisted_19, [_createVNode(_component_standard_button, {
      outlined: true,
      label: _ctx.$t('analytics.userQuizzesResultsDialog.cancelBtn'),
      onAction: _ctx.closePopup
    }, null, 8, ["label", "onAction"]), _createVNode(_component_standard_button, {
      label: _ctx.$t('analytics.userQuizzesResultsDialog.exportToPdfBtn'),
      disabled: _ctx.isExporting,
      loading: _ctx.isExporting,
      onAction: _ctx.exportToPdf
    }, null, 8, ["label", "disabled", "loading", "onAction"])])]),
    key: "0"
  } : undefined]), 1032, ["visible", "title", "onOnDialogClose"]);
}